module.exports = __webpack_public_path__ + "static/img/main_bg01.5984227.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/main/main_bg01.png
// module id = zuH4
// module chunks = 1